import * as fromRanking from "../actions/ranking.actions";
import { Ranking } from "src/app/shared/interfaces/ranking";
import { RankingScope } from "src/app/shared/interfaces/ranking-scope";
import { RankingCriteria } from "src/app/shared/models/ranking-criteria";
import { EmptyRanking } from "src/app/shared/models/ranking";

export interface RankingState {
  ranking: Ranking;
  getRankingCompleted: boolean;
  getRankingFailed: boolean;
  rankingUnavailable: boolean;
  manualRefreshing: boolean;
  rankingCriteria: RankingCriteria;
  scopes: Array<RankingScope>;
  getScopesCompleted: boolean;
  getScopesFailed: boolean;
}

export const initialState: RankingState = {
  ranking: null,
  getRankingCompleted: false,
  getRankingFailed: false,
  rankingUnavailable: false,
  manualRefreshing: false,
  rankingCriteria: new RankingCriteria(),
  scopes: [],
  getScopesCompleted: false,
  getScopesFailed: false,
};

export function reducer(
  state = initialState,
  action: fromRanking.RankingActions,
): RankingState {
  switch (action.type) {
    case fromRanking.GET_RANKING:
      return {
        ...state,
        getRankingCompleted: false,
        getRankingFailed: false,
        rankingUnavailable: false,
        manualRefreshing: false,
      };

    case fromRanking.GET_RANKING_COMPLETED:
      return {
        ...state,
        getRankingCompleted: true,
        getRankingFailed: false,
        rankingUnavailable: false,
        manualRefreshing: false,
        ranking: action.payload,
      };

    case fromRanking.GET_RANKING_FAILED:
      return {
        ...state,
        getRankingCompleted: true,
        getRankingFailed: action.payload.error,
        rankingUnavailable: !!action.payload.unavailable,
        manualRefreshing: false,
        ranking: new EmptyRanking(),
      };

    case fromRanking.REFRESH_RANKING:
      return {
        ...state,
        manualRefreshing: state.manualRefreshing || action.manual,
      };

    case fromRanking.REFRESH_RANKING_FAILED:
      return {
        ...state,
        manualRefreshing: false,
      };

    case fromRanking.GET_RANKING_SCOPES:
      return {
        ...state,
        getRankingCompleted: false,
        getScopesCompleted: false,
        getScopesFailed: false,
      };

    case fromRanking.GET_RANKING_SCOPES_COMPLETED:
      return {
        ...state,
        scopes: action.payload,
        getScopesCompleted: true,
        getScopesFailed: false,
      };

    case fromRanking.GET_RANKING_SCOPES_FAILED:
      return {
        ...state,
        scopes: [],
        getScopesCompleted: true,
        getScopesFailed: true,
      };

    case fromRanking.UPDATE_RANKING_CRITERIA:
      return {
        ...state,
        rankingCriteria: action.payload,
      };

    default:
      return state;
  }
}
